import React from "react";

const NewsContainersOutcomesItems = ({ index }) => {
  return (
    <div
      style={{
        background: "rgba(255,255,255,0.1)",
        border: "1px solid rgba(255,255,255,0.2)",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.75rem",
        color: "#aaa",
        aspectRatio: "1 / 1", // Forces each individual item to remain square
        cursor: "pointer",
        transition: "background 0.2s ease",
      }}
      onMouseOver={(e) =>
        (e.currentTarget.style.background = "rgba(255,255,255,0.2)")
      }
      onMouseOut={(e) =>
        (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
      }
    >
      {/* Placeholder text until the database hookup is ready */}
      Ocancerz
    </div>
  );
};

export default NewsContainersOutcomesItems;
